var MiniCart = {
	init:function(){
		Debug.log("MINI CART INIT");
		$(".header .woocommerce-cart").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			MiniCart.open_cart();
		});
		$(".mini-cart-container .close").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			
			MiniCart.close_cart();
		})
		
		$("body").on("wc_fragments_loaded", function(){
			Debug.log("MINI CART LOADED");
			
			MiniCart.open_cart();
			
			
		})
	},
	open_cart:function(){
		$(".mini-cart-container").addClass("open");
	},
	close_cart:function(){
		$(".mini-cart-container").removeClass("open");
	}
}

$(window).load(function(){
	if($(".mini-cart-container").length){
		MiniCart.init();
		
	}
})